export default __webpack_public_path__ + "static/media/image5.2635993d.png";